import { useState, useEffect, useCallback } from 'react';
import { getJobsByLeadId } from '../api/jobs-api';
import type { JobListItemDto } from '../types';

/**
 * Hook for fetching all jobs for a specific lead
 */
export function useJobsByLead(leadId: number | undefined) {
  const [data, setData] = useState<JobListItemDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchJobs = useCallback(async () => {
    if (!leadId) {
      setData([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);
    try {
      const jobs = await getJobsByLeadId(leadId);
      setData(jobs);
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to fetch jobs for lead');
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, [leadId]);

  useEffect(() => {
    fetchJobs();
  }, [fetchJobs]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchJobs,
  };
}
